export const scrollToElementId = (elId) => {
    let rect = document.getElementById(elId).getBoundingClientRect(),
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    window.scrollTo(0, rect.top + scrollTop - 100);
};


// WEBPACK FOOTER //
// ./services/dom/elementScroller.js